
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/warehouses/error-handling",
      function () {
        return require("private-next-pages/events/warehouses/error-handling.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/warehouses/error-handling"])
      });
    }
  